'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * From keppelen/react-facebook-login
 * Extract the value for a given key in a url-encoded parameter string
 *
 * @param      {String} paramString The encoded parameter string
 * @param      {String} key The target key
 * @return     {Object} Decoded value for given parameter key
 */

exports.default = function (paramString, key) {
  return decodeURIComponent(paramString.replace(new RegExp('^(?:.*[&\\?]' + //
  encodeURIComponent(key).replace(/[.+*]/g, '\\$&') + // This will add \ before all . or + or * of the encoded key
  '(?:\\=([^&]*))?)?.*$', 'i'
  // (?:\=([^&]*))?) Capturing the group (string) start with = to &
  // 'i' for case-insensitive
  // By example, with http://test.com?code=aCode&r=rrr&b=bbbb, it will return aCode if the key is code
  // The regExp will find aCode and the string will be replace by this.
  ), '$1'));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FacebookLoginButton/FacebookLogin/decodeParam.js
// module id = 1953
// module chunks = 0